module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "pro_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/pro01#pro01"
    }
  }, [_vm._v("PROLOGUE")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The head caretaker, Tryggvi, stood by the coffeemaker. The water…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#ch01"
    }
  }, [_vm._v("CHAPTER 1")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra Gudmundsdóttir brushed a stray Cheerio from her trousers and…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#ch02"
    }
  }, [_vm._v("CHAPTER 2")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra looked at the clock and put down the documents…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03#ch03"
    }
  }, [_vm._v("CHAPTER 3")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra was not usually afraid of thieves, but on her…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("There turned out to be five sheets of paper in…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra reached the day care on time. She met the…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Finding a parking space at the national hospital was definitely…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("There were few people at the Intercultural Center. Thóra had…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Gunnar Gestvík, head of the department of history at the…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra spun around slowly on the shiny parquet floor of…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Laura Amaming looked at her watch. Fortunately it was only…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra was sitting at Harald Guntlieb’s desk, browsing through the…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The effects of divorce are not all positive. Thóra had…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra was sitting at her computer in her office when…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("“Don’t be a jerk.” Marta Mist pursed her lips and…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("“Nothing,” said Thóra, looking up in frustration from her computer…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra was holding a small tan leather wallet that she…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("“How do you do? My name’s Gunnar Gestvík, head of…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra straightened up and leaned back in her chair. She…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Hey, dead Harald.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra had read well into the night and she woke…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra had not seen so much bad posture in one…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Matthew showed the students to the door. Meanwhile, Thóra and…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Dóri was enormously relieved as he hurried away from the…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_24"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The good weather from the previous evening seemed likely to…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_25"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The stately approach to the main building of the University…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_26"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The journey to Rangá went like a dream. The weather…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_27"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra woke up with her head throbbing as if her…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_28"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra was determined not to cancel the dinner invitation. As…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_29"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The young woman bore no resemblance to her mother, but…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_30"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra felt uncomfortable sitting at the police station. She was…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_31"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra regarded Halldór silently. He was sitting directly opposite her…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_32"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Thóra sat drumming on the edge of her desk with…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_33"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Matthew looked at Thóra and shook his head. They were…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "epi_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/epi01#epi01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Amelia Guntlieb stared at the tabletop, silent as the grave.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ata01#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ABOUT THE AUTHOR")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "cre_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/cre01#cre01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CREDITS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/cop01#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COPYRIGHT")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/atp01#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE PUBLISHER")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0